import React, { Component } from 'react';
import { Link, View, Text, isWeb } from 'core';
import { css, theme } from 'constants';

export class RadioGroup extends Component {
  state = { selected: '' };
  constructor(props) {
    super(props);
    props.selected_option && this.setState({ selected: props.selected_option });
  }
  render() {
    let { options, onValueChange, style, button_style, color, size, text_color } = this.props;
    const { selected } = this.state;
    size = size || 26;
    size = isWeb ? size - 4 : size;
    const radius = size / 2;
    color = color || theme.primary_color;
    return (
      <View style={style}>
        {options.map((option, index) => (
          <Link
            onPress={() => {
              onValueChange(option.value, index, option.text);
              this.setState({ selected: option.text });
            }}
            style={style}
            key={index}
          >
            <View style={[styles.big_circle, button_style, { height: size, width: size, borderRadius: radius, borderColor: color }]}>
              {selected === option.text ? (
                <View style={[styles.circle, { backgroundColor: color }, { height: size - 8, width: size - 8, borderRadius: radius - 4 }]} />
              ) : null}
            </View>
            <Text style={{ color: text_color }}>{option.text}</Text>
          </Link>
        ))}
      </View>
    );
  }
}

const styles = css({
  big_circle: {
    margin: 5,
    borderWidth: 1,
    marginRight: 10,
    justifyContent: 'center',
    alignItems: 'center'
  },
  circle: {
    margin: 5,
    borderColor: theme.primary_color,
    borderWidth: 1,
    backgroundColor: theme.primary_color
  }
});



// WEBPACK FOOTER //
// ./src/components/core/radio_group.js